// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadDocError-module__wrapper--e4323","hint":"LoadDocError-module__hint--f4281"};